<template>
  <div class="box">
    <img src="../assets/img/logo.png" alt="" />
    <div class="login_box">
      <h2>投稿登录</h2>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm form"
      >
        <el-form-item prop="username" class="log_item">
          <el-input v-model="ruleForm.username" placeholder="账号">
            <i slot="prefix" class="el-icon-user-solid"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" class="login_hei">
          <el-input
            type="password"
            v-model="ruleForm.password"
            placeholder="密码"
          >
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <template>
            <div class="login_out">
              <el-checkbox-group v-model="ruleForm.type">
                <el-checkbox label="记住我" name="type"></el-checkbox>
              </el-checkbox-group>
              <p style="cursor: pointer;"  @click="$router.push('/Repwd')">忘记密码?</p>
            </div>
          </template>
        </el-form-item>

        <el-form-item>
          <div class="login_fot">
            <el-button @click="submitForm" class="sbmit">登录</el-button>
            <el-button @click="$router.push('/Register')" class="first">
              立即注册
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="login_ftr">
           <p> Copyright (c) 2020   京ICP备15005281号-1 All Rights Reserved</p>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      ruleForm: {
        username: localStorage.getItem('username') || '',
        password: localStorage.getItem('password') || '',
        type: localStorage.getItem('password') ? ['记住我'] : []
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  components: {},
  methods: {
    async submitForm (formName) {
      if (this.ruleForm.type[0] == '记住我') {
        localStorage.setItem('username', this.ruleForm.username)
        localStorage.setItem('password', this.ruleForm.password)
      }

      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          const res = await this.$api.Home.login(this.ruleForm)
          if (res.code == 0) {
            this.$message.success('登录成功')
            window.localStorage.setItem(
              'token',
              'Bearer ' + res.data.access_token
            )
            this.$router.push('/PapInt')
          } else {
            this.$message.error(res.msg)
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
  background: url('../assets/img/bg.png') no-repeat center;
  background-size: 100% 100%;

  .login_box {

    width: 600px;
    height: 540px;
    background-color: #ffffff;
    border-radius: 27px;
    margin: 40px auto 0;
    padding: 39px 60px 57px 60px;
    box-sizing: border-box;

    h2 {
      height: 34px;
      font-family: SourceHanSansCN-Regular;
      font-size: 36px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #00599e;

      text-align: center;
    }
    .form {
      margin-top: 40px;
      .sbmit {
        margin-bottom: 10px;
      }
      .first {
        background-color: #e73917 !important;
      }
      .login_hei {
        margin-bottom: 0 !important;
      }
      .login_out {
        display: flex;
        height: 60px;
        justify-content: space-between;
        p {
          font-family: SourceHanSansCN-Regular;
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 80px;
          letter-spacing: 0px;
          color: #00599e;
        }
      }
      .login_fot {
        display: flex;
        flex-wrap: wrap;
        button {
          cursor: pointer;
          width: 480px;
          height: 60px;
          background-color: #00599e;
          border-radius: 5px;
          margin-left: 0 !important;
          font-family: 'SourceHanSansCN-Regular';
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #ffffff;
          border: 0;
        }
      }
    }
  }
  img {
    padding-top: 139px;
    // box-sizing: border-box;
    width: 132px;
    height: 130px;
    margin: 0 auto;
    display: block;
  }
}
/deep/.el-form-item {
  margin-bottom: 20px !important;
}
/deep/.el-icon-user-solid,
.el-icon-lock {
  font-size: 22px !important;
  color: #0072ca;
  margin-top: 3px;
  margin-left: 2px;
}
/deep/.el-checkbox__label {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 80px;
  letter-spacing: 0px;
  color: #333333;
}
/deep/.el-input__inner {
  height: 60px !important;
}
/deep/ .el-input__prefix,
.el-input__suffix {
  line-height: 64px;
}
</style>
